export default __webpack_public_path__ + "static/media/List.9602dad7.less";